// getShowcaseListIndexes.js
'use strict';
import { Collection, List } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

import getOperationData from '../selector/getOperationData.js';
import getShowcaseListItems from '../selector/getShowcaseListItems.js';

const getIndexes = ({
  activeIndex,
  featuredItemAmount,
  featuredListingAmount,
}) => {
  const center = Math.floor(featuredItemAmount / 2);
  const list = [];

  for (let i = -center; i <= center; i++) {
    let index = i + activeIndex;

    if (Math.abs(index) >= featuredListingAmount) {
      index = index % featuredListingAmount;
    }

    if (index >= featuredListingAmount) {
      index = featuredListingAmount - index;
    } else if (index < 0) {
      index = featuredListingAmount + index;
    }

    const duplicatedAmount = list.filter(item => item.index === index).length;

    list.push({ index, key: `${duplicatedAmount}-${index}` });
  }

  return list;
};

/**
 * Select showcase indexes
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {array} The selected showcase indexes.
 */
const getShowcaseListIndexes = createCachedSelector(
  (state, showcaseType) => getShowcaseListItems(state, showcaseType),
  state => getOperationData(state, ['showcase'], 'activeIndex'),
  state => getOperationData(state, ['showcase'], 'itemAmount'),
  (showcase, activeIndex, featuredItemAmount) => {
    let result;

    const featuredListingAmount = showcase.length;

    if (featuredListingAmount === 0) {
      result = List(
        new Array(featuredItemAmount)
          .fill(null)
          .map((item, index) => ({ index: item, key: index }))
      );
    } else {
      result = List(
        getIndexes({
          activeIndex,
          featuredItemAmount,
          featuredListingAmount,
        })
      );
    }

    return result instanceof Collection ? result.toJS() : result;
  }
)(() => 'getShowcaseListIndexes');

export default getShowcaseListIndexes;
